import type {
  MenuLinkTreeFirstFragment,
  MenuLinkTreeSecondFragment,
  MenuLinkTreeThirdFragment,
} from '#graphql-operations'
import { notNullish } from '@vueuse/core'

export type MappedLink = {
  label: string
  url: string
  id: string
  children?: MappedLink[]
}

export function mapTreeItem(
  item:
    | MenuLinkTreeFirstFragment
    | MenuLinkTreeSecondFragment
    | MenuLinkTreeThirdFragment,
): MappedLink | null {
  const label = item.link.label
  if (!label) {
    return null
  }

  const url = item.link.url?.path
  if (!url) {
    return null
  }

  const id = item.link.content?.id

  if (!id) {
    return null
  }

  const children =
    'subtree' in item && item.subtree.length
      ? item.subtree.map(mapTreeItem).filter(notNullish)
      : []

  return {
    label,
    url,
    id,
    children: children.length ? children : undefined,
  }
}

export enum NavbarFirstLevelType {
  Default = 'default',
  Social = 'social',
  Search = 'search',
}

export interface NavbarFirstLevelItem {
  link: {
    type: NavbarFirstLevelType
    label: string
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    content?: any
    url?: { path?: string }
  }
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  subtree: any[]
}

export const COLOR_MAP: Record<string, string> = {
  '856': 'rose',
  '847': 'slate',
  '844': 'brown',
  '838': 'burgundy',
  '829': 'warning',
  '823': 'grey',
  '832': 'success',
  '820': 'sky',
  '841': 'fawn',
  '835': 'lime',
  '853': 'orange',
  '850': 'pink',
  '826': 'danger',
  '811': 'black',
  '817': 'violett',
  '814': 'primary',
}

export default function (tid: string | number): string {
  const key = String(tid)
  return COLOR_MAP[key] || ''
}
